module.exports = __webpack_public_path__ + "img/discordLight.d09d6aae.svg";